// extracted by mini-css-extract-plugin
export var actionText = "_iy-4";
export var container = "_iy-0";
export var leftSection = "_iy-1";
export var rightSection = "_iy-2";
export var settingsButton = "_iy-6";
export var settingsIcon = "_iy-7";
export var shortcut = "_iy-5";
export var shortcutGroup = "_iy-3";